import { render, staticRenderFns } from "./baseCustomsDeclarationType.vue?vue&type=template&id=c34791f0&"
import script from "./baseCustomsDeclarationType.vue?vue&type=script&lang=js&"
export * from "./baseCustomsDeclarationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c34791f0')) {
      api.createRecord('c34791f0', component.options)
    } else {
      api.reload('c34791f0', component.options)
    }
    module.hot.accept("./baseCustomsDeclarationType.vue?vue&type=template&id=c34791f0&", function () {
      api.rerender('c34791f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseCustomsDeclarationType.vue"
export default component.exports